import { useEffect, useState } from 'react';
import { VIDEO_WALL_UNASSIGNED_ASSIGN_DELAY_MS } from 'store/transactionsSlice/transactionConstants';

const remainingDelay = (unassignedSince) => (unassignedSince == null ? 0 : unassignedSince + VIDEO_WALL_UNASSIGNED_ASSIGN_DELAY_MS - Date.now());

/**
 * Whether manual assign is allowed yet on an Unassigned lane.
 *
 * @param {number|null|undefined} unassignedSince when this browser received the lane's detection (ms); nullish means nothing to wait for
 * @returns {boolean} true once VIDEO_WALL_UNASSIGNED_ASSIGN_DELAY_MS has passed since unassignedSince
 */
const useUnassignedLaneAssignDelay = (unassignedSince) => {
    const [elapsedFor, setElapsedFor] = useState(null);

    // Derived on every render rather than kept in state, so a lane that turns Unassigned again (new detection,
    // new unassignedSince) is disabled on its very first render instead of flashing the previous lane's result.
    const isElapsed = remainingDelay(unassignedSince) <= 0 || elapsedFor === unassignedSince;

    useEffect(() => {
        const remaining = remainingDelay(unassignedSince);
        if (remaining <= 0) return undefined;

        const timeoutId = setTimeout(() => setElapsedFor(unassignedSince), remaining);
        return () => clearTimeout(timeoutId);
    }, [unassignedSince]);

    return isElapsed;
};

export default useUnassignedLaneAssignDelay;
